import { MsalProvider } from '@azure/msal-react'
import { createTheme, ThemeProvider } from '@material-ui/core'
import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import './App.css'
import HomeLayout from './components/Layout/HomeLayout'
import { msalInstance } from './services/msal'
require('dotenv').config()

const theme = createTheme({
  palette: {
    primary: {
      main: '#205527',
    },
    secondary: {
      main: '#000',
    },
    error: {
      main: '#ef5350',
    },
  },
})

export default class App extends React.Component {
  render() {
    return (
      <MsalProvider instance={msalInstance}>
        <Router>
          <ThemeProvider theme={theme}>
            <HomeLayout />
          </ThemeProvider>
        </Router>
      </MsalProvider>
    )
  }
}
